export const API_VERSION = {
  V1: 'v1',
  V2: 'v2',
  V_GRAVITY: 'gravity/v1',
};

export const API_MODULE = {
  API: 'api',
  VELOCITY: 'velocity',
  GRAVITY: 'gravity',
};

export const API_TYPE = {
  INSIGHTS: 'insights',
  SESSIONS: 'sessions',
  STUDENTS: 'students',
  USERS: 'users',
  UTILITIES: 'utilities',
};

const API_ENDPOINTS = {
  AI_TUTOR_GET_CURRENT_SESSION: `/ai-tutor/session/get-current-session`,
  AI_PROFILES: `/ai_profiles`,
  AI_TRIAL_CONTENT: `student/ai-trial-content`,
  PAST_SESSION: `ai-tutor/session`,
  AI_TUTOR_CONCEPT_SESSION_ENABLE: `student/ai-trial-enable`,
  AITUTOR_DATA: `${API_TYPE.SESSIONS}/ai-data`,
  AI_TRIAL_ENABLE: `/student/ai-trial-enable`,
  CREATE_PRACTICE_SESSION: `ai-tutor/session/create`,
  ASSESSMENTS: `${API_TYPE.STUDENTS}/assessments`,
  ASSIGNMENTS: `assignments`,
  ASSIGNMENT_NOTIFICATIONS: `/assignments/notifications`,
  AVATARS: `${API_TYPE.UTILITIES}/avatars`,
  BADGES: `badges`,
  CREATE_SESSION: `ai-tutor/session/create`,
  CHAPTER_STRENGTH: `${API_TYPE.INSIGHTS}/chapter-strength`,
  COURSE_CLASSES: `/course-classes`,
  COURSE_SUBJECTS: `${API_TYPE.STUDENTS}/course-subjects`,
  GET_SUBJECTS: `/content/subjects`,
  GET_SESSION_NOTE: `${API_TYPE.SESSIONS}/{sessionId}/classnotes`,
  GENERATE_CLASS_NAME: `text/generate-class-name`,
  JOURNEY: '/journey',
  LIFE_SKILL: `${API_TYPE.UTILITIES}/life-skill`,
  LIVE_CLASSES_LIST: `${API_TYPE.SESSIONS}`,
  LIVE_TESTS_LIST: `sessions`,
  LOGIN: `/auth/v1/login`,
  PRE_READS: 'prereads',
  PRACTICED_QUESTIONS: 'practiced-questions',
  PROGRESS: `${API_VERSION.V2}/ai-tutor/session/sessionId/progress`,
  PREPARE_AI_TUTOR_SESSION: `slides/prepare-ai-session`,
  QUESTIONS: '/questions',
  REVIEW: 'review',
  RELATED_QUESTIONS: 'related-questions',
  SEND_OTP: `/auth/v1/signin`,
  VERIFY_OTP: `/auth/v1/otp/verify`,
  SESSIONS: `/sessions`,
  SESSION: "session",

  SSO_LOGIN_TOKEN: `/${API_TYPE.USERS}/sso-get-login-token`,
  SSO_LOGIN: `/${API_TYPE.USERS}/sso-login`,
  SUMBIT: `submit`,
  SUBSCRIPTIONS: `/${API_TYPE.STUDENTS}/subscriptions`,
  TEACHER: 'teachers',
  TOPICS: `topics`,
  TRIBYTE_REDIRECT_URL: `/users/tribyte-redirect-url`,
  TRIBYTE_TEST_ATTEMPTS_DETAILS: `/tribyte/test-attempts-details`,
  TRIBYTE_USER_TEST_LIST: '/tribyte/user-test-attempts',
  SAT_DASHBOARD_SUMMARY: '/sat/summary',
  QUOTE_OF_DAY: `${API_TYPE.UTILITIES}/personalized-quotes`,
  UPCOMING_TEST_OR_CLASS: 'sessions/upcoming',
  USER_INFO: `/${API_TYPE.USERS}/me`,
  // Test-related endpoints
  TESTS: `${API_TYPE.SESSIONS}/tests`,
  UPCOMING_TESTS: `session/tests/upcoming`,
  TESTS_WITH_UPLOAD_STATUS: `sessions/test`, // Velocity v1 endpoint for tests with upload status
  ASSESSMENT: `/assessment`,
  ASSESSMENT_RANK: `/assessment/{assessmentId}/rank`,
  PARAGRAPH: `/paragraph`,
  // Fallback test endpoints for test flow only
  TESTS_FALLBACK: `${API_TYPE.STUDENTS}/tests`,
  UPCOMING_TESTS_FALLBACK: `${API_TYPE.STUDENTS}/tests/upcoming`,
  SPARKY_ASSIGNMENT_SUBJECTS: `configs/sparky_assignment_subjects`,
  PRESENTATIONS: `${API_TYPE.SESSIONS}/presentations`,
  PRACTICE_CHAPTERS: `course/{courseId}/textbook/{textbookId}/subject/{subjectId}/chapter/with-sat-practice`,
  PRACTICE_STATS_SUMMARY: `practice/stats/summary`,
  PRACTICE_STATS_DAILY_PROGRESS: `practice/stats/daily-progress`,
  PRACTICE_STATS_SUBJECT_MASTERY: `practice/stats/subject-mastery`,
  PRACTICE_STATS_CHAPTERS: `practice/stats/chapters`,
  BU_ATTRIBUTES: 'bu-units/{buId}/attributes',
  PPT_VIDEOS: `/course/{courseId}/subject/{subjectId}/chapter/videos`,
  PRESENTATION_PLAYBACKS: `/presentation-playbacks`,
  CHAPTER_PRESENTATIONS: `/chapters/{chapterId}/presentations`,

  AI_STORYBOARD: `/presentations/{presentationId}/ai-storyboard`,
  PRESENTATION_AUDIO: `presentation/{presentationId}/audio`,
  SLIDES : `presentations/{presentationId}/with-slides`,
  PRESENTATION_SECTIONS : `presentations/{presentationId}/ai-presentation-slides`,
  CHAPTER_PRESENTATIONS_LIST : `chapters/{chapterId}/presentations`,
  CHAPTER_DETAILS : `chapters/{chapterId}/details`,
  CHAPTER_VIDEOS : `course/{courseId}/subject/{subjectId}/chapter/videos`,
};

export const getPptVideosUrl = (
  courseId: number | string,
  subjectId: number | string,
) => `/course/${courseId}/subject/${subjectId}/chapter/videos`;

export const getChapterPresentationsUrl = (chapterId: number | string) =>
  `/chapters/${chapterId}/presentations`;

export default API_ENDPOINTS;
